/**
 * The three figures across the top of the overview, plus the small dial each
 * system status carries.
 *
 * Unlike the instruments in gauges.ts these are not pure: they read the status
 * colours and the viewer's own tile arrangement, because what the hero draws is
 * "what needs attention", and a tile somebody has hidden does not.
 *
 * GENERATED by scripts/extract-gauges.mjs from .demo-src/original.js.
 */
// @ts-nocheck
/* eslint-disable */
import { hiCanvas, GO } from "../lib/canvas";
import { N } from "../lib/palette";
import { LAYOUT } from "../domain/layout";
import { t } from "../../i18n";

export function drawAttnBoard(c: HTMLCanvasElement, worst?: any, all?: any, H?: any): void{
  const hi = hiCanvas(c, H || 168);
  if (!hi) return;
  const { g, w, h } = hi;
  const nogo = all.filter((x: any) => x.state === "nogo"), caut = all.filter((x: any) => x.state === "caution");
  const go = all.filter((x: any) => x.state === "go"), idle = all.filter((x: any) => x.state === "idle");
  const total = Math.max(1, all.length);
  /* one bar showing the whole estate at a glance */
  const bx = 6, bw = w - 12, by = 30;
  let x = bx;
  [[nogo.length, "#FF4D45", "OUTSIDE"], [caut.length, "#F2B03A", "WATCH"],
   [go.length, "#3FD07A", "INSIDE"], [idle.length, N("#3A4C58"), "NOT FED"]].forEach(([n, col]: any[]) => {
    if(!n) return;
    const sw = bw*(n/total);
    g.fillStyle = col; g.shadowBlur = 8; g.shadowColor = col;
    g.fillRect(x, by, Math.max(2, sw), 22); g.shadowBlur = 0;
    if(sw > 22){
      g.font = "700 11px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'"; g.fillStyle = N("#08131B");
      g.fillText(String(n), x + 6, by + 16);
    }
    x += sw;
  });
  g.font = "700 8.5px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'"; g.fillStyle = "#5A7285";
  g.fillText(t("{n} INDICATORS", { n: all.length }), 6, 14);
  g.textAlign = "right";
  g.fillStyle = nogo.length ? "#FF6A66" : "#3FD07A";
  g.fillText(t("{nogo} OUTSIDE LIMITS · {caution} ON WATCH", { nogo: nogo.length, caution: caut.length }), w - 6, 14);
  g.textAlign = "left";
  /* by tier, so it is obvious whether the problem is safety or comfort */
  const tiers = [[1,"Safety critical"],[2,"Operational"],[3,"Passenger service"],
    [4,"Resilience"]];
  const rowY = by + 36;
  tiers.forEach((tier: any, i: any) => {
    const list = all.filter((x: any) => (LAYOUT.tiers[x.key] != null ? LAYOUT.tiers[x.key] : x.tier) === tier[0]);
    if(!list.length) return;
    const bad = list.filter((x: any) => x.state === "nogo").length;
    const wat = list.filter((x: any) => x.state === "caution").length;
    const y = rowY + i*20;
    g.font = "700 9.5px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'"; g.fillStyle = N("#C4D3DE");
    g.fillText(t(tier[1]).toUpperCase(), 6, y + 4);
    const tx0 = Math.min(132, w*0.40), tx1 = w - 58, tw = tx1 - tx0;
    g.fillStyle = N("#0B141C"); g.fillRect(tx0, y - 6, tw, 12);
    let xx = tx0;
    [[bad, "#FF4D45"], [wat, "#F2B03A"], [list.length - bad - wat, N("#22303B")]]
      .forEach(([n, col]: any[]) => { if(!n) return;
        const sw = tw*(n/list.length);
        g.fillStyle = col; g.fillRect(xx, y - 6, Math.max(1.5, sw), 12); xx += sw; });
    g.textAlign = "right";
    g.font = "700 9.5px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'";
    g.fillStyle = bad ? "#FF6A66" : wat ? "#F2B03A" : "#3FD07A";
    g.fillText(`${bad + wat}/${list.length}`, w - 6, y + 4);
    g.textAlign = "left";
  });
}

export function drawResolvedBoard(c: HTMLCanvasElement, R?: any, H?: any): void{
  const hi = hiCanvas(c, H || 168);
  if (!hi) return;
  const { g, w, h } = hi;
  const wk = R.week;
  const max = Math.max(1, ...wk.map((x: any) => Math.max(x.raised, x.closed)));
  const dialR = Math.min(30, h*0.22), dialX = 40, dialY = 26 + dialR + 8;
  /* closure rate as an arc */
  const rate = R.closureRate == null ? 0 : Math.min(1.3, R.closureRate);
  const col = R.closureRate == null ? "#5A7285" : R.closureRate >= 1 ? "#3FD07A"
    : R.closureRate >= 0.8 ? "#F2B03A" : "#FF4D45";
  g.beginPath(); g.arc(dialX, dialY, dialR, Math.PI*0.75, Math.PI*2.25);
  g.lineWidth = 8; g.strokeStyle = N("#16222C"); g.lineCap = "round"; g.stroke();
  g.beginPath(); g.arc(dialX, dialY, dialR, Math.PI*0.75,
    Math.PI*0.75 + Math.PI*1.5*Math.max(0.02, Math.min(1, rate/1.3)));
  g.strokeStyle = col; g.lineWidth = 8; g.shadowBlur = 10; g.shadowColor = col;
  g.stroke(); g.shadowBlur = 0; g.lineCap = "butt";
  g.textAlign = "center";
  g.font = "700 16px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'"; g.fillStyle = col;
  g.fillText(R.closureRate == null ? "—" : Math.round(R.closureRate*100) + "%", dialX, dialY + 4);
  g.font = "700 7.5px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'"; g.fillStyle = N("#6E8496");
  g.fillText(t("CLOSED PER"), dialX, dialY + 16);
  g.fillText(t("RAISED, 90d"), dialX, dialY + 25);
  g.textAlign = "left";
  /* the twelve week picture */
  const x0 = 88, x1 = w - 10, base = h - 24, top = 32;
  const cw = (x1 - x0)/wk.length;
  g.strokeStyle = N("#16222C"); g.lineWidth = 1;
  g.beginPath(); g.moveTo(x0, base); g.lineTo(x1, base); g.stroke();
  wk.forEach((x: any, i: any) => {
    const bx = x0 + i*cw + 2, bw = (cw - 6)/2;
    const rh = (base - top)*(x.raised/max), ch = (base - top)*(x.closed/max);
    g.fillStyle = "#FF6B63"; g.globalAlpha = .85;
    g.fillRect(bx, base - rh, bw, rh); g.globalAlpha = 1;
    g.fillStyle = "#3FD07A"; g.shadowBlur = 5; g.shadowColor = "#3FD07A";
    g.fillRect(bx + bw + 2, base - ch, bw, ch); g.shadowBlur = 0;
  });
  g.font = "700 8px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'";
  g.fillStyle = "#FF6B63"; g.fillText(t("■ RAISED"), x0, 14);
  g.fillStyle = "#3FD07A"; g.fillText(t("■ CLOSED"), x0 + 58, 14);
  if(w > 340){ g.fillStyle = "#5A7285"; g.fillText(t("12 WEEKS"), x0 + 118, 14); }
  g.textAlign = "right";
  g.font = "700 8px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'"; g.fillStyle = N("#6E8496");
  g.fillText(R.median == null ? t("no closure time yet") : t("MEDIAN {n}d", { n: R.median }), w - 6, 14);
  g.fillStyle = "#5A7285";
  g.fillText(t("{n} STILL OPEN", { n: R.backlog }), w - 6, h - 8);
  g.textAlign = "left";
}

export function drawHeroStrip(c: HTMLCanvasElement, stats?: any, H?: any): void{
  const hi = hiCanvas(c, H || 104);
  if (!hi) return;
  const { g, w, h } = hi;
  const n = stats.length, cw = w/n;
  stats.forEach((s2: any, i: any) => {
    const cx = cw*i + cw/2, cy = 44, R = Math.min(cw/2 - 12, 26);
    const sc = s2.score == null ? 0.03 : Math.max(0, Math.min(1, s2.score));
    const col = sc > 0.7 ? "#3FD07A" : sc > 0.35 ? "#F2B03A" : "#FF4D45";
    /* dial */
    g.beginPath(); g.arc(cx, cy, R, Math.PI*0.75, Math.PI*2.25);
    g.strokeStyle = N("#16222C"); g.lineWidth = 6; g.lineCap = "round"; g.stroke();
    g.beginPath(); g.arc(cx, cy, R, Math.PI*0.75, Math.PI*0.75 + Math.PI*1.5*sc);
    g.strokeStyle = col; g.lineWidth = 6;
    g.shadowBlur = 10; g.shadowColor = col; g.stroke(); g.shadowBlur = 0; g.lineCap = "butt";
    for(let k = 0; k <= 6; k++){
      const a = Math.PI*0.75 + Math.PI*1.5*(k/6);
      g.beginPath();
      g.moveTo(cx + Math.cos(a)*(R+5), cy + Math.sin(a)*(R+5));
      g.lineTo(cx + Math.cos(a)*(R+8), cy + Math.sin(a)*(R+8));
      g.strokeStyle = "rgba(140,163,179,.35)"; g.lineWidth = 1; g.stroke();
    }
    g.textAlign = "center";
    const big = String(s2.v);
    g.font = `700 ${big.length > 5 ? 12 : big.length > 3 ? 14 : 16}px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'`;
    g.fillStyle = col; g.shadowBlur = 8; g.shadowColor = col + "88";
    g.fillText(big, cx, cy + 5); g.shadowBlur = 0;
    g.font = "700 9.5px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'"; g.fillStyle = N("#C4D3DE");
    g.fillText(t(s2.k).toUpperCase(), cx, cy + R + 18);
    g.font = "700 8px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'"; g.fillStyle = N("#6E8496");
    const sub = String(s2.sub || "");
    const room = Math.floor(cw/5.2);
    g.fillText(sub.length > room ? sub.slice(0, room-1) + "…" : sub, cx, cy + R + 30);
    g.textAlign = "left";
    if(i < n-1){
      g.strokeStyle = N("#16222C"); g.lineWidth = 1;
      g.beginPath(); g.moveTo(cw*(i+1), 10); g.lineTo(cw*(i+1), h - 8); g.stroke();
    }
  });
}

export function drawMini(c: HTMLCanvasElement, score?: any, state?: any): void{
  const hi = hiCanvas(c, 48);
  if (!hi) return;
  const { g, w, h } = hi;
  const cx = h/2, cy = h/2, R = h/2 - 5;
  g.beginPath(); g.arc(cx, cy, R, 0, 6.284); g.lineWidth = 5;
  g.strokeStyle = N("#16222C"); g.stroke();
  g.beginPath(); g.arc(cx, cy, R, -Math.PI/2, -Math.PI/2 + 6.284*Math.max(0.02, score));
  g.lineWidth = 5; g.strokeStyle = GO[state];
  g.shadowBlur = 10; g.shadowColor = GO[state]; g.stroke(); g.shadowBlur = 0;
  g.textAlign = "center"; g.font = "700 10.5px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'";
  g.fillStyle = N("#E9F0F5"); g.fillText(Math.round(score*100), cx, cy+4);
  g.textAlign = "left";
}

export function drawCapacity(c: HTMLCanvasElement, cp?: any, H?: any): void{
  const hi = hiCanvas(c, H || 168);
  if (!hi) return;
  const { g, w, h } = hi;
  if(!cp || cp.worstU == null){
    g.fillStyle = N("#3A4C58"); g.font = "700 10.5px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'";
    g.fillText(t("DECLARED CAPACITY NOT SET"), 4, 20);
    g.font = "700 9px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'"; g.fillStyle = N("#2F3E49");
    g.fillText(t("aerodrome manual and slot file"), 4, 34);
    return;
  }
  const pad = 26, x0 = pad, x1 = w - 8;
  const chartH = Math.round((h - 34)*0.56), base = 34 + chartH, top = 34;
  /* hourly profile */
  const hrs = cp.hourly.length ? cp.hourly : [];
  const decl = cp.declared || Math.max(1, ...hrs.map((x: any) => x.mv));
  const max = Math.max(decl*1.15, ...hrs.map((x: any) => x.mv));
  const Y = (v: any) => base - chartH*(v/max);
  const cw = hrs.length ? (x1 - x0)/hrs.length : 0;
  g.strokeStyle = N("#16222C"); g.lineWidth = 1;
  [0, 0.5, 1].forEach((f: any) => {
    const y = base - chartH*f*(decl/max);
    g.beginPath(); g.moveTo(x0, y); g.lineTo(x1, y); g.stroke();
  });
  hrs.forEach((x: any, i: any) => {
    const bx = x0 + i*cw + 1, bw = Math.max(2, cw - 2);
    const over = x.mv > decl;
    const col = over ? "#FF4D45" : x.mv > decl*0.85 ? "#F2B03A" : "#4C9BE8";
    /* arrivals and departures stacked, so the peak can be read by where it comes from */
    const ah = chartH*(x.arr/max), dh = chartH*(x.dep/max);
    g.fillStyle = col; g.globalAlpha = .95;
    g.fillRect(bx, base - ah, bw, ah);
    g.globalAlpha = .55; g.fillRect(bx, base - ah - dh, bw, dh);
    g.globalAlpha = 1;
    if(over){ g.shadowBlur = 9; g.shadowColor = col;
      g.fillRect(bx, Y(x.mv), bw, 2); g.shadowBlur = 0; }
  });
  /* the declared rate, as a limit line */
  const dy = Y(decl);
  g.setLineDash([5,3]); g.strokeStyle = "#FF6A66"; g.lineWidth = 1.4;
  g.beginPath(); g.moveTo(x0, dy); g.lineTo(x1, dy); g.stroke(); g.setLineDash([]);
  g.font = "700 8px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'"; g.fillStyle = "#FF9A96";
  g.fillText(t("DECLARED {n}/HR", { n: decl }), x0 + 2, dy - 3);
  /* hour ticks */
  g.font = "700 7px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'"; g.fillStyle = N("#3A4C58");
  hrs.forEach((x: any, i: any) => { if(i % 3) return;
    g.textAlign = "center";
    g.fillText(String(x.h).padStart(2,"0"), x0 + i*cw + cw/2, base + 9); g.textAlign = "left"; });
  g.fillStyle = N("#3A4C58"); g.fillText("0", 2, base + 3);
  g.fillText(String(Math.round(max)), 2, top + 6);
  /* headline: what binds, and by how much */
  const b = cp.binding;
  g.font = "700 8px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'"; g.fillStyle = N("#6E8496");
  g.fillText(t("TIGHTEST CONSTRAINT"), x0, 10);
  const bc = cp.worstU >= 1 ? "#FF4D45" : cp.worstU >= 0.85 ? "#F2B03A" : "#3FD07A";
  g.font = "700 13px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'"; g.fillStyle = bc;
  g.fillText(`${b ? t(b.k).toUpperCase() : "—"} ${Math.round(cp.worstU*100)}%`, x0, 24);
  g.textAlign = "right";
  g.font = "700 8px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'"; g.fillStyle = N("#6E8496");
  g.fillText(t("HEADROOM"), w - 2, 10);
  g.font = "700 13px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'"; g.fillStyle = bc;
  g.fillText(`${Math.max(0, Math.round((1 - cp.worstU)*100))}%`, w - 2, 24);
  g.textAlign = "left";
  /* the three constraints as bars beneath the profile */
  const rows = cp.constraints;
  const ry0 = base + 16, rowH = (h - ry0 - 4)/rows.length;
  rows.forEach((r: any, i: any) => {
    const y = ry0 + i*rowH + rowH/2;
    const lw = 60, bx = x0 + lw, bw2 = x1 - bx - 44;
    g.font = "700 9px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'"; g.fillStyle = N("#9DB2C0");
    g.fillText(t(r.k).toUpperCase(), 2, y + 3);
    g.fillStyle = N("#101B24"); g.fillRect(bx, y - 5, bw2, 10);
    g.strokeStyle = N("#22303B"); g.strokeRect(bx + .5, y - 4.5, bw2 - 1, 9);
    if(r.u != null){
      const col = r.u >= 1 ? "#FF4D45" : r.u >= 0.85 ? "#F2B03A" : "#3FD07A";
      g.fillStyle = col; g.shadowBlur = 6; g.shadowColor = col;
      g.fillRect(bx, y - 5, Math.min(bw2, bw2*r.u), 10); g.shadowBlur = 0;
      /* the 85% caution mark, where a constraint stops being comfortable */
      g.strokeStyle = "#F2B03A"; g.globalAlpha = .7;
      g.beginPath(); g.moveTo(bx + bw2*0.85, y - 6); g.lineTo(bx + bw2*0.85, y + 6);
      g.stroke(); g.globalAlpha = 1;
      g.textAlign = "right"; g.font = "700 10px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'"; g.fillStyle = col;
      g.fillText(Math.round(r.u*100) + "%", w - 2, y + 4); g.textAlign = "left";
    } else {
      g.font = "700 8px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'"; g.fillStyle = N("#3A4C58");
      g.fillText(t("NOT FED"), bx + 4, y + 3);
    }
  });
}

export function drawPaxChart(c: HTMLCanvasElement, p?: any, H?: any): void{
  const hi = hiCanvas(c, H || 128);
  if (!hi) return;
  const { g, w, h } = hi;
  if(!p || !p.monthly.length){
    g.fillStyle = N("#3A4C58"); g.font = "700 11px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'";
    g.fillText(t("PASSENGER FEED NOT CONNECTED"), 4, h/2); return;
  }
  const M = ["J","F","M","A","M","J","J","A","S","O","N","D"];
  const pad = 22, base = h - 16, top = 26;
  const x0 = pad, x1 = w - 8, cw = (x1 - x0)/12;
  const val = (m: any) => m == null ? 0 : (m.pax ?? m);
  const all = p.monthly.map(val).concat(p.forecast.map(val)).concat(p.lastMonthly.map(val));
  const max = Math.max(1, ...all);
  const Y = (v: any) => base - (base - top)*(v/max);
  /* gridlines */
  g.strokeStyle = N("#16222C"); g.lineWidth = 1;
  for(let i = 0; i <= 3; i++){
    const y = base - (base-top)*i/3;
    g.beginPath(); g.moveTo(x0, y); g.lineTo(x1, y); g.stroke();
    g.font = "700 7.5px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'"; g.fillStyle = N("#3A4C58");
    g.fillText(((max*i/3)/1000).toFixed(0) + "k", 2, y + 3);
  }
  /* this year, measured */
  p.monthly.forEach((m: any, i: any) => {
    const x = x0 + i*cw + 2, bw = cw - 4, v = val(m);
    const grd = g.createLinearGradient(0, Y(v), 0, base);
    grd.addColorStop(0, "#4C9BE8"); grd.addColorStop(1, "#4C9BE822");
    g.fillStyle = grd; g.shadowBlur = 7; g.shadowColor = "#4C9BE8";
    g.fillRect(x, Y(v), bw, base - Y(v)); g.shadowBlur = 0;
  });
  /* the rest of the year, forecast — outline only */
  p.forecast.forEach((f: any) => {
    const i = f.month, x = x0 + i*cw + 2, bw = cw - 4, v = val(f);
    g.setLineDash([3,3]); g.strokeStyle = "#7FB2CC"; g.lineWidth = 1.2;
    g.strokeRect(x + .5, Y(v) + .5, bw - 1, base - Y(v) - 1);
    g.setLineDash([]);
    g.fillStyle = "rgba(127,178,204,.10)"; g.fillRect(x, Y(v), bw, base - Y(v));
  });
  /* last year, as a line to compare against */
  if(p.lastMonthly.length){
    g.beginPath();
    p.lastMonthly.forEach((m: any, i: any) => {
      const x = x0 + i*cw + cw/2, y = Y(val(m));
      i ? g.lineTo(x, y) : g.moveTo(x, y);
    });
    g.strokeStyle = "#B47BE0"; g.lineWidth = 1.8; g.lineJoin = "round";
    g.shadowBlur = 6; g.shadowColor = "#B47BE0"; g.stroke(); g.shadowBlur = 0;
    p.lastMonthly.forEach((m: any, i: any) => {
      g.beginPath(); g.arc(x0 + i*cw + cw/2, Y(val(m)), 1.8, 0, 6.284);
      g.fillStyle = "#D9C2F0"; g.fill();
    });
  }
  /* month letters, this year's months in white */
  g.font = "700 8px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'";
  M.forEach((lab: any, i: any) => {
    g.fillStyle = i < p.monthly.length ? N("#8CA3B3") : N("#3A4C58");
    g.textAlign = "center"; g.fillText(lab, x0 + i*cw + cw/2, h - 4); g.textAlign = "left";
  });
  /* the three figures that matter, across the top */
  const fmt = (v: any) => v >= 1e6 ? (v/1e6).toFixed(2) + "M" : Math.round(v/1000) + "k";
  const chips = [
    ["YTD", fmt(p.ytd), "#4C9BE8"],
    ["LAST YR", p.last ? fmt(p.last) : "—", "#B47BE0"],
    ["FORECAST", fmt(p.projected), "#3FD07A"]
  ];
  let cx2 = x0;
  chips.forEach(([lab, v, col]: any[]) => {
    g.font = "700 8px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'"; g.fillStyle = N("#6E8496");
    g.fillText(t(lab), cx2, 10);
    g.font = "700 12.5px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'"; g.fillStyle = col;
    g.fillText(v, cx2, 22);
    cx2 += Math.max(58, w*0.20);
  });
  if(p.yoy != null){
    const up = p.yoy >= 0, col = up ? "#3FD07A" : "#FF6A66";
    g.textAlign = "right";
    g.font = "700 12px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'"; g.fillStyle = col;
    g.fillText(`${up ? "▲" : "▼"} ${Math.abs(p.yoy*100).toFixed(1)}%`, w - 2, 22);
    g.font = "700 7.5px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'"; g.fillStyle = N("#6E8496");
    g.fillText(t("ON LAST YEAR"), w - 2, 10);
    g.textAlign = "left";
  }
}

export function drawPaxCumulative(c: HTMLCanvasElement, p?: any, H?: any): void{
  const hi = hiCanvas(c, H || 132);
  if (!hi) return;
  const { g, w, h } = hi;
  if(!p || !p.monthly.length){
    g.fillStyle = N("#3A4C58"); g.font = "700 11px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'";
    g.fillText(t("PASSENGER FEED NOT CONNECTED"), 4, h/2); return;
  }
  const val = (m: any) => m == null ? 0 : (m.pax ?? m);
  const cum = (arr: any) => arr.reduce((a: any, m: any, i: any) => (a.push((a[i-1] || 0) + val(m)), a), []);
  const ty = cum(p.monthly);
  const fc = cum(p.forecast).map((v: any) => v + (ty[ty.length-1] || 0));
  const ly = cum(p.lastMonthly);
  const pad = 26, base = h - 16, top = 28, x0 = pad, x1 = w - 8;
  const max = Math.max(1, ...ty, ...fc, ...ly);
  const X = (i: any) => x0 + (x1 - x0)*(i/11);
  const Y = (v: any) => base - (base - top)*(v/max);
  g.strokeStyle = N("#16222C");
  for(let i = 0; i <= 3; i++){
    const y = base - (base-top)*i/3;
    g.beginPath(); g.moveTo(x0, y); g.lineTo(x1, y); g.stroke();
    g.font = "700 7.5px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'"; g.fillStyle = N("#3A4C58");
    g.fillText(((max*i/3)/1e6).toFixed(1) + "M", 2, y + 3);
  }
  /* the gap between the two years, filled */
  if(ly.length){
    g.beginPath();
    ty.forEach((v: any, i: any) => i ? g.lineTo(X(i), Y(v)) : g.moveTo(X(i), Y(v)));
    for(let i = ty.length-1; i >= 0; i--) g.lineTo(X(i), Y(ly[i] || 0));
    g.closePath();
    const ahead = ty[ty.length-1] >= (ly[ty.length-1] || 0);
    g.fillStyle = ahead ? "rgba(63,208,122,.16)" : "rgba(255,77,69,.16)"; g.fill();
  }
  const line = (arr: any, col: any, dash: any, from: any) => {
    if(!arr.length) return;
    g.beginPath();
    arr.forEach((v: any, i: any) => { const xi = (from || 0) + i;
      (i ? g.lineTo : g.moveTo).call(g, X(xi), Y(v)); });
    g.setLineDash(dash || []); g.strokeStyle = col; g.lineWidth = 2; g.lineJoin = "round";
    g.shadowBlur = dash ? 0 : 8; g.shadowColor = col; g.stroke();
    g.shadowBlur = 0; g.setLineDash([]);
  };
  line(ly, "#B47BE0");
  line(ty, "#4C9BE8");
  if(fc.length) line([ty[ty.length-1]].concat(fc), "#3FD07A", [4,3], ty.length - 1);
  g.beginPath(); g.arc(X(ty.length-1), Y(ty[ty.length-1]), 3.2, 0, 6.284);
  g.fillStyle = N("#E9F0F5"); g.fill();
  const fmt = (v: any) => v >= 1e6 ? (v/1e6).toFixed(2) + "M" : Math.round(v/1000) + "k";
  const chips = [["YTD", fmt(p.ytd), "#4C9BE8"], ["LAST YR", p.last ? fmt(p.last) : "—", "#B47BE0"],
    ["FORECAST", fmt(p.projected), "#3FD07A"]];
  let cx = x0;
  chips.forEach(([lab, v, col]: any[]) => {
    g.font = "700 8px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'"; g.fillStyle = N("#6E8496");
    g.fillText(t(lab), cx, 10);
    g.font = "700 12.5px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'"; g.fillStyle = col;
    g.fillText(v, cx, 22); cx += Math.max(58, w*0.20);
  });
  g.font = "700 8px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'"; g.fillStyle = N("#6E8496");
  g.textAlign = "right"; g.fillText(t("CUMULATIVE PACE"), w - 2, 10); g.textAlign = "left";
}

export function drawPaxDelta(c: HTMLCanvasElement, p?: any, H?: any): void{
  const hi = hiCanvas(c, H || 132);
  if (!hi) return;
  const { g, w, h } = hi;
  if(!p || !p.monthly.length || !p.lastMonthly.length){
    g.fillStyle = N("#3A4C58"); g.font = "700 10px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'";
    g.fillText(t("LAST YEAR NOT SUPPLIED — NOTHING TO COMPARE"), 4, h/2); return;
  }
  const M = ["J","F","M","A","M","J","J","A","S","O","N","D"];
  const val = (m: any) => m == null ? 0 : (m.pax ?? m);
  const rows = [];
  for(let i = 0; i < 12; i++){
    const ly = val(p.lastMonthly[i]);
    const cur = i < p.monthly.length ? val(p.monthly[i]) : null;
    const f = p.forecast.find((x: any) => x.month === i);
    const v = cur != null ? cur : (f ? f.pax : null);
    rows.push({i, pct:ly && v != null ? (v - ly)/ly : null, forecast:cur == null});
  }
  const pad = 30, x0 = pad, x1 = w - 8, mid = h/2 + 4, half = (h - 34)/2;
  const max = Math.max(0.05, ...rows.filter((r: any) => r.pct != null).map((r: any) => Math.abs(r.pct)));
  const cw = (x1 - x0)/12;
  g.strokeStyle = N("#2B3A46"); g.lineWidth = 1;
  g.beginPath(); g.moveTo(x0, mid); g.lineTo(x1, mid); g.stroke();
  [0.5, 1].forEach((f: any) => [-1,1].forEach((sgn: any) => {
    const y = mid - sgn*half*f;
    g.strokeStyle = N("#16222C"); g.setLineDash([2,3]);
    g.beginPath(); g.moveTo(x0, y); g.lineTo(x1, y); g.stroke(); g.setLineDash([]);
    g.font = "700 7.5px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'"; g.fillStyle = N("#3A4C58");
    g.fillText((sgn > 0 ? "+" : "−") + (max*f*100).toFixed(0) + "%", 2, y + 3);
  }));
  rows.forEach((r: any) => {
    const x = x0 + r.i*cw + 3, bw = cw - 6;
    if(r.pct == null) return;
    const bh = half*(Math.abs(r.pct)/max);
    const up = r.pct >= 0, col = up ? "#3FD07A" : "#FF4D45";
    if(r.forecast){
      g.setLineDash([3,3]); g.strokeStyle = col; g.lineWidth = 1.2;
      g.strokeRect(x + .5, up ? mid - bh + .5 : mid + .5, bw - 1, bh - 1);
      g.setLineDash([]); g.fillStyle = col + "22";
      g.fillRect(x, up ? mid - bh : mid, bw, bh);
    } else {
      g.fillStyle = col; g.shadowBlur = 7; g.shadowColor = col;
      g.fillRect(x, up ? mid - bh : mid, bw, bh); g.shadowBlur = 0;
    }
    g.font = "700 7.5px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'"; g.fillStyle = col;
    g.textAlign = "center";
    g.fillText((up ? "+" : "") + (r.pct*100).toFixed(0), x + bw/2, up ? mid - bh - 3 : mid + bh + 9);
    g.textAlign = "left";
  });
  g.font = "700 8px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'";
  M.forEach((lab: any, i: any) => {
    g.fillStyle = i < p.monthly.length ? N("#8CA3B3") : N("#3A4C58"); g.textAlign = "center";
    g.fillText(lab, x0 + i*cw + cw/2, h - 3); g.textAlign = "left";
  });
  g.font = "700 8px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'"; g.fillStyle = N("#6E8496");
  g.textAlign = "right"; g.fillText(t("MONTH ON SAME MONTH LAST YEAR"), w - 2, 10); g.textAlign = "left";
}

export function drawGauge(c: HTMLCanvasElement, score?: any, state?: any): void{
  const hi = hiCanvas(c, 244);
  if (!hi) return;
  const { g, w, h } = hi;
  const cx = w/2, cy = h*0.82, R = Math.min(w*0.42, h*0.78);
  const a0 = Math.PI*1.0, a1 = Math.PI*2.0;
  g.lineCap = "round";
  // track
  g.beginPath(); g.arc(cx, cy, R, a0, a1); g.lineWidth = 16;
  g.strokeStyle = N("#16222C"); g.stroke();
  // coloured zones
  const zones = [[0,0.45,"#FF4D45"],[0.45,0.75,"#F2B03A"],[0.75,1,"#3FD07A"]];
  for(const [s,e,col] of zones){
    g.beginPath(); g.arc(cx, cy, R, a0 + (a1-a0)*s, a0 + (a1-a0)*e);
    g.lineWidth = 5; g.strokeStyle = col + "55"; g.stroke();
  }
  // value arc with glow
  const grd = g.createLinearGradient(cx-R, 0, cx+R, 0);
  grd.addColorStop(0, "#2E9BE0"); grd.addColorStop(0.55, GO[state]); grd.addColorStop(1, GO[state]);
  g.beginPath(); g.arc(cx, cy, R, a0, a0 + (a1-a0)*Math.max(0.015, score));
  g.lineWidth = 16; g.strokeStyle = grd;
  g.shadowBlur = 24; g.shadowColor = GO[state]; g.stroke(); g.shadowBlur = 0;
  // ticks
  for(let i = 0; i <= 20; i++){
    const a = a0 + (a1-a0)*(i/20), long = i % 5 === 0;
    const r0 = R - 24, r1 = R - (long ? 34 : 29);
    g.beginPath();
    g.moveTo(cx + Math.cos(a)*r0, cy + Math.sin(a)*r0);
    g.lineTo(cx + Math.cos(a)*r1, cy + Math.sin(a)*r1);
    g.lineWidth = long ? 2 : 1;
    g.strokeStyle = long ? "rgba(233,240,245,.5)" : "rgba(140,163,179,.28)";
    g.stroke();
  }
  // needle
  const na = a0 + (a1-a0)*Math.max(0.015, score);
  g.beginPath();
  g.moveTo(cx + Math.cos(na+Math.PI/2)*6, cy + Math.sin(na+Math.PI/2)*6);
  g.lineTo(cx + Math.cos(na)*(R-30), cy + Math.sin(na)*(R-30));
  g.lineTo(cx + Math.cos(na-Math.PI/2)*6, cy + Math.sin(na-Math.PI/2)*6);
  g.closePath(); g.fillStyle = N("#E9F0F5"); g.fill();
  g.beginPath(); g.arc(cx, cy, 9, 0, 6.284);
  g.fillStyle = N("#0B1620"); g.fill(); g.strokeStyle = GO[state]; g.lineWidth = 2.5; g.stroke();
  // readout
  g.textAlign = "center";
  g.font = "700 46px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'";
  g.fillStyle = GO[state];
  g.shadowBlur = 18; g.shadowColor = GO[state] + "88";
  g.fillText(Math.round(score*100), cx, cy - 34);
  g.shadowBlur = 0;
  g.font = "600 12px ui-monospace,Menlo,monospace,'IBM Plex Sans Arabic'";
  g.fillStyle = N("#8CA3B3"); g.fillText(t("READINESS INDEX"), cx, cy - 14);
  g.textAlign = "left";
}
